import React from "react"

export const LocationContext = React.createContext({})
export const LocationContextProvider = LocationContext.Provider
export const LocationContextConsumer = LocationContext.Consumer
